export default __webpack_public_path__ + "static/Entenda0134-29c68edcf4bbebf09c14a5aef861775e.jpg";